import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    margin: 8px 0;\n    min-height: ", ";\n    ", ";\n    color: ", ";\n\n    &:empty {\n        margin: 4px 0;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { confirmable, createConfirmation } from 'react-confirm';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '../Dialog';
import { TextField } from '../TextField';
import { Button } from '../Button';
import { LabelledContent } from '../LabelledContent';
import { Form } from '../Form';
import { typography } from '../mixins';
import { ThemeProvider } from '../ThemeProvider';
import theme from '../themes/default.theme';
var ErrorMessage = styled.span(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.body2.lineHeight;
}, typography('body2'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.error.main;
});
var QuickReply = styled(Button)(_templateObject2());
export var Prompt = confirmable(function (_a) {
  var show = _a.show,
      proceed = _a.proceed,
      cancel = _a.cancel,
      confirmation = _a.confirmation,
      _a$options = _a.options,
      _a$options$inputProps = _a$options.inputProps,
      inputProps = _a$options$inputProps === void 0 ? {} : _a$options$inputProps,
      _a$options$initialVal = _a$options.initialValue,
      initialValue = _a$options$initialVal === void 0 ? '' : _a$options$initialVal,
      _a$options$quickRepli = _a$options.quickReplies,
      quickReplies = _a$options$quickRepli === void 0 ? [] : _a$options$quickRepli,
      title = _a$options.title,
      okText = _a$options.okText,
      cancelText = _a$options.cancelText,
      _a$options$quickRepli2 = _a$options.quickRepliesTitle,
      quickRepliesTitle = _a$options$quickRepli2 === void 0 ? '' : _a$options$quickRepli2,
      beforeSubmit = _a$options.beforeSubmit,
      props = __rest(_a, ["show", "proceed", "cancel", "confirmation", "options"]);

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isWorking = _useState6[0],
      setIsWorking = _useState6[1];

  var errorMessage = "".concat(error.code || '', " ").concat(error.message || '').trim();
  var setQuickReply = useCallback(function (event) {
    var reply = event.currentTarget.value;
    var startsWithReply = quickReplies.find(function (qr) {
      return value.startsWith(qr);
    });
    var newValue = startsWithReply ? value.replace(startsWithReply, reply) : reply + '\n\n' + value;
    var trimmedValue = inputProps.maxLength != null ? newValue.substr(0, inputProps.maxLength) : newValue;
    setValue(trimmedValue.trim());
  }, [value, quickReplies]);
  var quickRepliesList = quickReplies.map(function (reply) {
    return React.createElement(QuickReply, {
      key: reply,
      value: reply,
      variant: 'text',
      disabled: isWorking,
      onClick: setQuickReply,
      type: 'button'
    }, reply);
  });
  var handleValueChange = useCallback(function (_ref3) {
    var value = _ref3.target.value;
    return setValue(value);
  }, []);
  var submitPrompt = useCallback(function () {
    if (typeof beforeSubmit === 'function') {
      setIsWorking(true);
      beforeSubmit(value).then(function () {
        setIsWorking(false);
        setError({});
        return proceed(value);
      }, function (error) {
        setIsWorking(false);
        setError(error);
      });
    } else {
      proceed(value);
    }
  }, [beforeSubmit, proceed, value]);
  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Dialog, Object.assign({}, props, {
    opened: show,
    onClose: cancel
  }), React.createElement(Form, {
    onSubmit: submitPrompt
  }, React.createElement(DialogTitle, null, title), React.createElement(DialogContent, null, React.createElement(TextField, Object.assign({}, inputProps, {
    autoFocus: true,
    fullWidth: true
  }, inputProps.multiline && {
    rows: 4,
    maxRows: 4
  }, {
    placeholder: confirmation,
    value: value,
    readOnly: isWorking,
    onChange: handleValueChange
  })), React.createElement(ErrorMessage, null, errorMessage), quickReplies.length > 0 && React.createElement(LabelledContent, {
    label: quickRepliesTitle
  }, quickRepliesList)), React.createElement(DialogActions, null, React.createElement(Button, {
    variant: 'text',
    disabled: isWorking,
    onClick: cancel,
    type: 'button'
  }, cancelText), React.createElement(Button, {
    working: isWorking
  }, okText)))));
});
export var prompt = createConfirmation(Prompt);